<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_supplier_bankName') || '开户银行'"
            prop="bankName"
          >
            <el-input
              v-model.trim="formData.bankName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="small"
              type="text"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_supplier_bankAccountName') || '账户名称'"
            prop="bankAccountName"
          >
            <el-input
              v-model.trim="formData.bankAccountName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="small"
              type="text"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_supplier_bankAccountNo') || '银行账号'"
            prop="bankAccountNo"
          >
            <el-input
              v-model.trim="formData.bankAccountNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="small"
              type="text"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_supplier_bankAccountType') || '账户性质'"
            prop="bankAccountType"
          >
            <el-select
              size="small"
              v-model="formData.bankAccountType"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
              @change="handleChange"
            >
              <el-option
                v-for="item in bankAccountOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_supplier_bankAccountKind') || '账号类别'"
            prop="bankAccountKind"
          >
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.bankAccountKind"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :body="bankAccountKindParams"
              url="/master/common/dict/biz"
              :selectedLabel.sync="formData.v_bankAccountKind"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    form: { type: Object, default: () => {} },
    type: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      bankAccountOptions: [
        {
          label: this.$l('INDEX.form_label_company') || '公司',
          value: '0',
        },
        {
          label: this.$l('INDEX.form_label_personal') || '个人',
          value: '1',
        },
      ],
      rules: {
        bankName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        bankAccountName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        bankAccountNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],

        bankAccountType: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],

        bankAccountKind: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    form: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      if (this.type && this.type !== 'add') {
        this.formData = { ...this.form }
        return
      }
      this.formData.uuid = this.form.uuid
    },
    async getForm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      return this.formData
    },
    handleChange(val) {
      var obj = this.bankAccountOptions.find((item) => item.value === val)

      this.formData.v_bankAccountType = obj ? obj.label : ''
    },
  },
}
</script>
